<script>
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";

  export let title = "";
  export let subtitle = "";
  export let thumbnail = "";
  export let backArrowIcon = "";
  export let backCopy = "";
  export let margin = "";
  export let rightAligned = "";
  export let selectedCheckmark = "";

  let initialPos;

  onMount(() => {
    animationIn();
  });

  function animationIn() {
    //Hide instructions
    let instructions = document.getElementById("instructions");

    if (rightAligned) {
      initialPos = "-10%";
    } else {
      initialPos = "+10%";
    }

    var animationIn_TL = new TimelineMax();
    animationIn_TL
      .set([instructions, ".title", ".subtitle", ".video-container", ".back"], {
        opacity: 0,
      })
      .add("init")
      .staggerTo(
        [".title", ".subtitle", ".video-container", ".back"],
        0,
        { opacity: 1 },
        0.1,
        "init"
      )
      .from(".body", 2, { x: initialPos }, "init");
  }

  function animationOut() {
    var animationOut_TL = new TimelineMax();
    animationOut_TL
      .add("init")
      .to(".body", 0.2, { opacity: 0 }, "init")
      .add(function () {
        dispatch("close", false);
      })
      .to([instructions], 0.5, { opacity: 1 });
  }

  const dispatch = createEventDispatcher();

  function back() {
    animationOut();
  }

  function openVideo() {
    dispatch("open-video", true);
    log2('media', 'video-play');
    loggin('media', 'video-play');
  }

  function videoHoverHandler() {
    let videoImg = document.getElementById("videoImg");
    videoImg.style.border = "solid 1px #149ED9";
  }

  function videoRollOutHandler() {
    let videoImg = document.getElementById("videoImg");
    videoImg.style.border = "solid 1px #404040";
  }

  function backHoverHandler() {
    let backLabel = document.getElementById("backLabel");
    let backSVG = document.getElementById("backSVG");
    backLabel.style.color = "#149ED9";
    backSVG.style.opacity = 1;
  }

  function backRollOutHandler() {
    let backLabel = document.getElementById("backLabel");
    let backSVG = document.getElementById("backSVG");
    backLabel.style.color = "#ffffff";
    backSVG.style.opacity = 0.75;
  }
</script>

<style type="text/scss">
  .feature-description {
    pointer-events: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;

    text-align: left;
    border-radius: 9px;
    width: 100%;
    min-width: 225px;
    max-width: 650px;
    display: flex;
    height: 95%;

    .body {

      width: 100%;
      height: 100%;
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      flex-direction: column;

      .title {
        color: #15b6eb;
        font-size: 1.2rem;
        padding-bottom: 0.2rem;
      }

      .subtitle {
        color: #ffffff;
        font-size: 0.8rem;
        padding-bottom: 1rem;
      }

      .header {
        width: 100%;
        margin-top: 0.5rem;
        align-self: flex-start;
      }
    }

    .video-container {
      width: 100%;
      align-self: flex-start;
    }

    .thumbnail {
      pointer-events: all;
      -webkit-user-select: all;
      -moz-user-select: all;
      -ms-user-select: all;
      user-select: all;
      width: 100%;
      height: auto;
      margin-bottom: 0.25rem;
    }

    #videoImg {
      border: 1px solid #404040;
    }

    .back {
      width: 100%;
      height: 1rem;
      display: flex;
      pointer-events: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;

    
    }

    .back-arrow {
      float: left;
      margin-right: 0.2rem;
      width: 10%;
    }

    .back-button {
      color: #ffffff;
      text-decoration: underline;
      font-size: 0.8rem;
      width: auto;
      pointer-events: all;
      -webkit-user-select: all;
      -moz-user-select: all;
      -ms-user-select: all;
      user-select: all;
    }
  }

  .right-aligned {
    text-align: right;
    align-self: auto;
  }

  .right-alignedBack {
    padding-left: 75%;
  }

  .selected-Checkmark {
    opacity: 1;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 42px;
    height: 42px;
    z-index: 5;
  }
</style>

<div
  class={rightAligned ? 'feature-description right-aligned' : 'feature-description'}
  style="margin: {margin}">
  <img class="selected-Checkmark" src={selectedCheckmark} alt="back" />

  <div class="body">
    <div class="header">
      <p class="title">
        {@html title}
      </p>
      <p class="subtitle">
        {@html subtitle}
      </p>
    </div>
    <div class="video-container">
      <div
        class={rightAligned ? 'thumbnail right-alignedVideo' : 'thumbnail'}
        on:click={openVideo}
        on:mouseenter={videoHoverHandler}
        on:mouseleave={videoRollOutHandler}>
        <img id="videoImg" class="img" src={thumbnail} alt="video" />
      </div>
      <div
        class={rightAligned ? 'back right-alignedBack' : 'back'}
       >
        <img
          id="backSVG"
          class="img back-arrow"
          src={backArrowIcon}
          alt="back" />
        <p id="backLabel" class="back-button" on:click={back}
        on:mouseenter={backHoverHandler}
        on:mouseleave={backRollOutHandler}>{backCopy}</p>
      </div>
    </div>
  </div>
</div>
